import { useTranslate } from "@similarweb/i18n-provider";
import { IconButton, PromoBanner } from "@similarweb/ui-components";
import { Flex, Box } from "@similarweb/ui-components/foundations";

import { INDUSTRY_TAXONOMY_DEMO_COPY_NAMESPACE } from "app/pages/sales-intelligence/modules/industry/constants";
import { useEnterIndustryTaxonomyDemo } from "app/pages/sales-intelligence/modules/industry/hooks/useEnterIndustryTaxonomyDemo";
import { useIsIndustryTaxonomyOptedIn } from "app/pages/sales-intelligence/modules/industry/hooks/useIsIndustryTaxonomyOptedIn";
import { demoModeKeys } from "app/pages/sales-intelligence/utils/i18n/demo-mode";

/**
 * Company-overview counterpart of the home offer — same audience and same demo, minus the badge, the article link
 * and the illustration. Self-gated, so the page renders it unconditionally.
 */
export const IndustryTaxonomyPromoBanner = () => {
    const { translate } = useTranslate();

    const isIndustryTaxonomyOptedIn = useIsIndustryTaxonomyOptedIn();

    const handleTryItOut = useEnterIndustryTaxonomyDemo();

    if (isIndustryTaxonomyOptedIn) {
        return null;
    }

    return (
        <Box
            data-automation="industry-taxonomy-promo-banner"
            marginY="24px 0"
        >
            <PromoBanner>
                <PromoBanner.Content>
                    <PromoBanner.Title data-automation="industry-taxonomy-promo-banner-title">
                        {translate(demoModeKeys.companyBannerTitle(INDUSTRY_TAXONOMY_DEMO_COPY_NAMESPACE))}
                    </PromoBanner.Title>

                    <PromoBanner.Description data-automation="industry-taxonomy-promo-banner-description">
                        {translate(demoModeKeys.companyBannerDescription(INDUSTRY_TAXONOMY_DEMO_COPY_NAMESPACE))}
                    </PromoBanner.Description>
                </PromoBanner.Content>

                <Flex flexShrink={0}>
                    <IconButton
                        type="primary"
                        buttonHtmlType="button"
                        iconName="arrow-right"
                        iconSize="12px"
                        placement="right"
                        onClick={handleTryItOut}
                        data-automation="industry-taxonomy-promo-banner-cta"
                    >
                        {translate(demoModeKeys.companyBannerCta(INDUSTRY_TAXONOMY_DEMO_COPY_NAMESPACE))}
                    </IconButton>
                </Flex>
            </PromoBanner>
        </Box>
    );
};
